import Vue from 'vue';
import _store from '@/store';
import { getHex } from "@/utils/color";

export { _store as store };

/*
  // Shared Data Functions
*/

const maxStudent = 500;

export const state = Vue.observable({
  classroomId: null,
  totalStudent: {
    total: 0,
    chartOptions: {
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0
        }
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2.5
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 0.9,
          opacityFrom: 0.5,
          opacityTo: 0.2,
          stops: [0, 80, 100]
        }
      },
      xaxis: {
        type: 'numeric',
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: { show: false }
      },
      yaxis: [{
        y: 0,
        offsetX: 0,
        offsetY: 0,
        padding: { left: 0, right: 0 },
      }],
      tooltip: {
        enabled: false,
        x: { show: false }
      },
      theme: {
        monochrome: {
          enabled: true,
          color: getHex('warning'),
          shadeTo: 'light',
          shadeIntensity: 0.65
        }
      }
    },
    chartSeries: [
      {
        name: '',
        data: [28, 40, 36, 52, 38, 60, 55]
      }
    ],
  },
  studentInEachUnitSeries: {
    options: {
      chartOptions: {
        chart: {
          id: "chart2",
          type: "area",
          height: 350,
          foreColor: "#ccc",
          toolbar: {
            autoSelected: "pan",
            show: false
          }
        },
        colors: [getHex("primary"), "#ddd"],
        stroke: {
          width: 3,
          curve: 'smooth'
        },
        grid: {
          borderColor: "#f9f9f9",
          clipMarkers: false,
          yaxis: {
            lines: {
              show: true
            }
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -10,
          background: {
            enabled: false,
          }
        },
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.7,
            opacityTo: 0
          }
        },
        markers: {
          size: 7,
          colors: ["#fff"],
          strokeColor: [getHex("primary"), "#ccc"],
          strokeWidth: 3
        },
        tooltip: {
          // theme: "dark"
          x: {
            formatter: function (value) {
              return "หน่วยการเรียนที่ " + value
            }, 
          }
        },
        legend: {
          show: true,
        },
        xaxis: {
          type: "category",
          labels: {
            style: {
              colors: [],
              fontSize: '1rem',
            },
            offsetY: 2,
          },
          categories: [
            "ยังไม่เริ่มต้นเรียน",
            1, 
            2, 
            3, 
            4, 
            5, 
            6, 
            7, 
            8, 
            9, 
            10,
            11,
            12,
            13,
            14,
            15
          ]
        },
        yaxis: {
          min: 0,
          tickAmount: 4
        }
      }
    },
    series: []
  },
  studentAccessHeatmap: {
    options: {
      chartOptions: {
        byweek: {
          title: {
            text: 'ข้อมูลรายสัปดาห์'
          },
          chart: {
            height: 500,
            type: 'heatmap',
          },
          plotOptions: {
            heatmap: {
              shadeIntensity: 0.8,
              radius: 0,
              useFillColorAsStroke: false,
              // colorScale: {
              //   ranges: [
              //     {
              //       from: -10,
              //       to: 0,
              //       name: 'none',
              //       color: "#999999"
              //     },
              //     {
              //       from: 1,
              //       to: 50,
              //       name: 'low',
              //       color: getHex("warning")
              //     },
              //     {
              //       from: 51,
              //       to: 100,
              //       name: 'high',
              //       color: getHex("success")
              //     }
              //   ]
              // }
            }
          },
          dataLabels: {
            enabled: true
          },
          legend: {
            show: true,
          },
          stroke: {
            width: 1
          },
        },
        summary: {
          title: {
            text: 'ข้อมูลรวม'
          },
          chart: {
            height: 600,
            type: 'heatmap',
          },
          plotOptions: {
            heatmap: {
              shadeIntensity: 0.7,
              radius: 0,
              useFillColorAsStroke: true,
              colorScale: {
                ranges: [
                  {
                    from: -10,
                    to: 0,
                    name: 'none',
                    color: "#999999"
                  },
                  /* {
                    from: 1,
                    to: maxStudent / 2,
                    name: 'low',
                    color: getHex("warning")
                  },
                  {
                    from: (maxStudent / 2) + 1,
                    to: maxStudent,
                    name: 'high',
                    color: getHex("success")
                  }, */
                  {
                    from: 1,
                    to: (maxStudent - (maxStudent / 4)),
                    name: '',
                    color: getHex("warning")
                  },
                  {
                    from: (maxStudent / 4) + 1,
                    to: (maxStudent / 4) * 3,
                    name: 'Low',
                    color: '#a7e8c4'
                  },
                  {
                    from: ((maxStudent / 4) * 3) + 1,
                    to: maxStudent,
                    name: 'High',
                    // color: getHex("success")
                    color: '#0b6c36',
                  },
                  {
                    from: maxStudent + 1,
                    to: maxStudent + 999,
                    name: 'Exceed',
                    color: getHex("danger")
                  },
                ]
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          legend: {
            show: true,
          },
          stroke: {
            width: 1
          },
        }
      },
    },
    series: []
  }
});

export const template = {};


/*
  // Shared Data Functions
*/


/*
  // Private Data Functions
*/

